<div class="modal-header">
    <h6 class="modal-title"><i class="bi bi-shield-check"></i> PAN KYC</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
    <form class="g-3" name="VerificationForm" (ngSubmit)="Verification(VerificationForm)" #VerificationForm="ngForm"
        novalidate>
        <div class="row">
            <div class="col-md-12">
                <div class="input-group mb-3">
                    <span class="input-group-text" id="lblPanNo">PAN No</span>
                    <input type="text" minlength="10" maxlength="10" class="form-control" placeholder="Pan No"
                        aria-label="Pan No" id="PanNo" 
                        (input) = "common.ToUpperCaseE($event)" name="PanNo"
                        pattern="[a-zA-Z]{5}[0-9]{4}[a-zA-Z]"
                        [(ngModel)]="PanDetail.PANNo" #PanNo="ngModel" maxlength="10" required
                        aria-describedby="lblPanNo" [disabled]="PanDetail.PANVerificationID==null?false:true">
                    <div class="invalid-feedback">
                        Please Enter 10 Digit Valid PAN Number eg.ABCDM0000X!
                    </div>
                </div>
            </div>
            <div class="col-md-12 m-1" *ngIf="ReturnDetail.PANVerificationID != null">
                <label style="color:var(--success)">Pan Verified Name</label><br />
                <label>{{ReturnDetail.NameAsPerPAN}}</label>
            </div>
        </div>
        <div class="row m-1">
            <button *ngIf="ReturnDetail.PANVerificationID == null" type="submit" class="btn btn-primary"
                [disabled]="isDisabled">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Verify':'Loading...'}}</button>

            <button *ngIf="ReturnDetail.PANVerificationID != null" type="button" class="btn btn-primary"
                [disabled]="isDisabled" (click)="Confirm()">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Confirm':'Loading...'}}</button>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled" (click)="close()"><i
            class="bi bi-x" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Cancel':'Loading...'}}</button>
</div>